<template>
  <div class="tabs is-separatedUnderlined is-fullwidth is-marginless-bottom is-borderless">
    <ul class="has-text-weight-medium is-borderless">
      <li v-for="(child, i) in children" :key="i"
          v-if="(!child.needProfile || child.needProfile.includes(currentUserProfil) || isSuperAdmin) && isEnabled"
          :class="{'is-active': child.routeName.includes($route.name)}">
        <router-link v-if="child.routeName"
                      :to="{'name':child.routeName}"
                      :key="child.routeName">
          <span v-if="child.iconClasses" class="icon is-small">
            <i :class="child.iconClasses"></i>
          </span>
          <span>{{child.text}}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { isNil } from 'lodash'

  export default {
    name: 'StatisticsMenu',
    mixins: [],
    components: {},
    props: {},
    data () {
      return {
        children: [{
          needProfile: ['admin', 'manager'],
          routeName: 'SaleStats',
          text: 'Réservations/Ventes',
          iconClasses: ['fas', 'fa-medal']
        },
        {
          needProfile: ['admin', 'manager'],
          routeName: 'SellerStats',
          text: 'Force de vente',
          iconClasses: ['fas', 'fa-users']
        },
        {
          needProfile: ['admin', 'manager'],
          routeName: 'RdvStats',
          text: 'Rendez-vous',
          iconClasses: ['fas', 'fa-calendar-check']
        },
        {
          needProfile: ['admin'],
          configs: ['MULTIDIFF_ENABLED'],
          routeName: 'Multidiffusion',
          text: 'Communication / Marketing',
          iconClasses: ['fas', 'fa-stream']
        }]
      }
    },
    computed: {
      ...mapState(['currentUser']),
      ...mapGetters(['currentUserProfil', 'currentUserPk', 'displayRemuneration', 'isAdmin', 'isManager', 'isSuperAdmin']),
      isEnabled () {
        if (isNil(this.children.configs) || this.link.children.length === 0) {
          return true
        }
        let enabled = true
        this.children.configs.forEach(config => {
          config = JSON.parse(this.$configs[config])
          if (config === 0 || config === 'false' || config === false) {
            enabled = false
          }
        })
        return enabled
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/statistics/StatsMenu.vue